<template>
  <div class="prize" ref="prize">
    <swiper class="swiper" :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="(item, index) in getShop" :key="index">
        <PrizeItem v-for="(e, i) in item" :item="e" :key="i" :pos="i" :discount="$bus.currentDiscount" />
      </swiper-slide>
    </swiper>
    <div class="swiper-control swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-control swiper-button-next" slot="button-next"></div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import PrizeItem from './prize-item'

export default {
  components: {
    PrizeItem,
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
    getShop () {
      const currentIndex = this.$bus.mapShopTypeToDiscount(this.$bus.shopType)
      const currentShop = currentIndex === 0 ? this.$bus.shopFood : currentIndex === 1 ? this.$bus.shopFishing : this.$bus.shopShoot
      return this.groupListByLen(JSON.parse(JSON.stringify(currentShop)))
    }
  },
  mounted () {
    this.documentBindClick()
  },
  beforeDestroy () {
    this.documentUnbindClick()
  },
  methods: {
    handleDocumentBindClick (e) {
      e.stopPropagation()
      const prize = this.$refs.prize
      if (!prize.contains(e.target)) {
        this.$bus.activeIndex = -1
      }
    },
    documentBindClick () {
      document.addEventListener('click', this.handleDocumentBindClick)
      document.addEventListener('touchend', () => {
        this.$bus.activeIndex = -1
      })
    },
    documentUnbindClick () {
      document.removeEventListener('click', this.handleDocumentBindClick)
    },
    groupListByLen (arr, len = 3) {
      if (!arr) {
        return []
      }
      const newArr = []
      while (arr.length > 0) {
        newArr.push(arr.splice(0, len))
      }
      return newArr
    }
  },
  watch: {
    '$bus.isFirst': {
      handler (current) {
        if (!current) {
          const currentIndex = this.$bus.mapShopTypeToDiscount(this.$bus.shopType)
          this.$bus.currentDiscount = this.$bus.discount[currentIndex]
        }
      }
    },
    // 切换商店update index
    '$bus.shopType': {
      handler (current) {
        this.$refs.mySwiper.$swiper.slideTo(0, 0)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.prize {
  position: absolute;
  @include px2res(top, 120);
  left: 50%;
  @include px2res(margin-left, -300);
  @include px2res(width, 600);

  .swiper-control {
    @include px2res(width, 45);
    @include px2res(height, 54);
    outline: none !important;

    &::after {
      display: none !important;
    }

    &.swiper-button-disabled {
      display: none;
    }

    &.swiper-button-next {
      @include px2res(right, -26, '!important');
    }

    &.swiper-button-prev {
      @include px2res(left, -26, '!important');
    }
  }

  .swiper-slide {
    display: flex !important;
    /* justify-content: space-between !important; */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shop/prize.vue